import { Box } from "@mui/material";
import { BestsellerBadge, CategoryBadge, CompanyText, ProductCard, ProductCardContent, ProductDescription, ProductLogo, ProductName, ProductReviewsLink, RatingValueText, StyledRating } from "./styles";
import { HeaderSubmenuAppClick, HeaderSubmenuAppReviewsClick } from "../../analytics/events";
import { useSelector, useDispatch } from "react-redux";
import { setActiveTab } from "@headless-shell/store";
import { useTranslatedObject } from "../../utils/translation";
import { handleProductClick } from "../../utils/helper";

const ProductCardItem = ({ product, navigate, activeTab }) => {
    const header = useTranslatedObject('header');
    const dispatch = useDispatch();
    const onCloseActiveTab = () => dispatch(setActiveTab(''));
    return (
        <ProductCard id={`marketplace-product-${product.id}`} onClick={(e) => handleProductClick({ e, product, navigate, activeTab, event: HeaderSubmenuAppClick, onCloseActiveTab })}>
             {product?.bestseller && <BestsellerBadge badgeContent="Bestseller"></BestsellerBadge>}
            <ProductCardContent>
                <Box display="flex" alignItems="flex-end" justifyContent="flex-start" mb={2} gap={1}>
                    <ProductLogo sx={{ bgcolor: product.logoColor }} src={product.logo} alt={product.name} />
                        <CategoryBadge label={product.category} />
                    </Box>
                    <ProductName>
                        {product.name}
                    </ProductName>

                    <CompanyText color="text.primary">
                        {header.by_company} {product.company}
                    </CompanyText>

                    <ProductDescription color="text.primary">
                        {product.description}
                    </ProductDescription>

                    {product?.rating > 0 && <Box display="flex" alignItems="center" mt="auto">
                        <RatingValueText>{product.rating.toFixed(1)}</RatingValueText>
                        <StyledRating value={product.rating} readOnly size="small" precision={0.1} />
                        <ProductReviewsLink underline="hover" onClick={(e) => handleProductClick({ e, product, navigate, activeTab, tab:'reviews', event: HeaderSubmenuAppReviewsClick, onCloseActiveTab })}>
                        {product.reviews} {header.reviews}
                        </ProductReviewsLink>
                    </Box>}
                    </ProductCardContent>
        </ProductCard>
    )
}

export const ProductCardList = ({ products, navigate }) => {
    const activeTab = useSelector((state) => state.app.activeTab);

    return products.map(product => (
        <ProductCardItem key={product.id} product={product} navigate={navigate} activeTab={activeTab} />
    ))
}